import { transformToPeriod } from '../Period/PeriodTransformers'
import { transformShiftPlanningV3 } from '../ShiftPlanning/ShiftPlanningTransformers'
import { ScheduleShift, ScheduleShiftResource } from './Shift'

export const transformScheduleShift = (resource: ScheduleShiftResource): ScheduleShift => ({
    ...resource,
    period: transformToPeriod(new Date(resource.start), new Date(resource.end)),
    shiftPlannings: resource.shiftPlannings.map(transformShiftPlanningV3),
})
